import { RenderAd } from '@pickleballinc/ui/components/advertisements/render-ad';
import { RenderFloatingAd } from '@pickleballinc/ui/components/advertisements/render-floating-ad';
import { Fragment } from 'react';

import { FeaturedPlayersContainer } from '@/components/FeaturedPlayersContainer/FeaturedPlayersContainer';
import { RenderCompanyWebsites } from '@/modules/homepage/RenderCompanyWebsites/RenderCompanyWebsites';
import { RenderFeaturedPartners } from '@/modules/homepage/RenderFeaturedPartners/RenderFeaturedPartners';
import { RenderHeadlines } from '@/modules/homepage/RenderHeadlines/RenderHeadlines';
import { RenderMLPLeaderboard } from '@/modules/homepage/RenderMLPLeaderboard/RenderMLPLeaderboard';
import { RenderNewsletter } from '@/modules/homepage/RenderNewsletter/RenderNewsletter';
import { RenderRankings } from '@/modules/homepage/RenderRankings/RenderRankings';
import { RenderRankingsV2 } from '@/modules/homepage/RenderRankingsV2/RenderRankingsV2';
import { RenderSideNews } from '@/modules/homepage/RenderSideNews/RenderSideNews';
import { RenderSocialMedia } from '@/modules/homepage/RenderSocialMedia/RenderSocialMedia';
import { ColumnWidgetTypes } from '@/types/homepage.types';
import { ColumnInterfaceExtended } from '@/utils/actions/homepage/getHomepageStructure';
import { IS_PRODUCTION } from '@/utils/helpers/constants';

export const RenderSidebar = ({
  widgets,
  ipAddress,
  className,
  showFromWidth,
}: ColumnInterfaceExtended) => {
  return (
    <div className={`hidden w-[300px] shrink-0 flex-col gap-4 py-6 xl:flex ${className}`}>
      {widgets.map((widget, index) => (
        <Fragment key={widget.uuid}>
          {widget.type === ColumnWidgetTypes.SIDE_NEWS && widget.metadata.prefetchedData ? (
            <RenderSideNews title={widget.metadata.title} news={widget.metadata.prefetchedData} />
          ) : widget.type === ColumnWidgetTypes.FEATURED_PLAYERS &&
            widget.metadata.prefetchedData ? (
            <FeaturedPlayersContainer
              {...widget.metadata}
              players={widget.metadata.prefetchedData}
            />
          ) : widget.type === ColumnWidgetTypes.SOCIAL_MEDIA ? (
            <RenderSocialMedia {...widget.metadata} />
          ) : widget.type === ColumnWidgetTypes.COMPANY_WEBSITES ? (
            <RenderCompanyWebsites {...widget.metadata} />
          ) : widget.type === ColumnWidgetTypes.FEATURED_PARTNERS ? (
            <RenderFeaturedPartners {...widget.metadata} />
          ) : widget.type === ColumnWidgetTypes.RANKINGS && widget.metadata.prefetchedData ? (
            <RenderRankings
              metadata={widget.metadata.data}
              rankings={widget.metadata.prefetchedData}
            />
          ) : widget.type === ColumnWidgetTypes.RANKINGS_V2 && widget.metadata.prefetchedData ? (
            <RenderRankingsV2
              metadata={widget.metadata.data}
              rankings={widget.metadata.prefetchedData}
            />
          ) : widget.type === ColumnWidgetTypes.MLP_LEADERBOARD &&
            widget.metadata.prefetchedData ? (
            <RenderMLPLeaderboard
              metadata={widget.metadata.data}
              rankings={widget.metadata.prefetchedData}
            />
          ) : widget.type === ColumnWidgetTypes.NEWSLETTER ? (
            <RenderNewsletter />
          ) : widget.type === ColumnWidgetTypes.HEADLINES && widget.metadata.prefetchedData ? (
            <RenderHeadlines headlines={widget.metadata.prefetchedData} />
          ) : widget.type === ColumnWidgetTypes.SIDE_ADVERTISEMENT ? (
            <>
              {/*Last advertisement in the sidebar column should be floating when scrolling*/}
              {index === widgets.length - 1 ? (
                <RenderFloatingAd
                  height={+widget.metadata.height}
                  ipAddress={ipAddress}
                  pageId={100000}
                  place={widget.metadata.place ? +widget.metadata.place : 0}
                  width={+widget.metadata.width}
                  placementId={widget.metadata.placementId}
                  zoneId={widget.metadata.zoneId}
                  isProd={IS_PRODUCTION}
                  showFromWidth={showFromWidth || 1280}
                />
              ) : (
                <RenderAd
                  height={+widget.metadata.height}
                  ipAddress={ipAddress}
                  pageId={100000}
                  place={widget.metadata.place ? +widget.metadata.place : 0}
                  width={+widget.metadata.width}
                  placementId={widget.metadata.placementId}
                  zoneId={widget.metadata.zoneId}
                  isProd={IS_PRODUCTION}
                  showFromWidth={showFromWidth || 1280}
                />
              )}
            </>
          ) : null}
        </Fragment>
      ))}
    </div>
  );
};
